







































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RowHeader extends Vue {
  private varietySort (name: string) {
    this.$emit('variety-sort', name)
  }
}
